// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2jWJg","emails":"CreateEditClinics_emails__pzcSX","emailTagLabel":"CreateEditClinics_emailTagLabel__2XpM_"};